import React, { useEffect, useState } from "react";
import "./WebinarPopup.css";
import PopUpForm from "./popup.jsx";

const WebinarPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

  // Show popup on page load
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <>
      <div className="popup-overlay">
        <div className="popup-box">
          <span className="close-btn" onClick={closePopup}>×</span>

          <section className="webinar-hero">
            <div className="webinar-content">
              <h1>
                Still Trading <span>Breakouts</span> Like Everyone Else?
              </h1>

              <p className="subheadline">
                Discover how smart money actually moves the market —
                and why retail traders are always late.
              </p>

              <p className="description">
                In this exclusive webinar, we’ll explore the concepts behind
                market structure, liquidity, and how institutional traders think.
              </p>

              <button className="cta-btn" onClick={() => setIsFormOpen(true)}>
                Reserve Your Seat
              </button>

              <p className="disclaimer">
                This webinar focuses on market understanding and education.
                No trading strategies or signals will be provided.
              </p>
            </div>
          </section>
        </div>
      </div>

      {/* Form popup */}
      {isFormOpen && <PopUpForm onClose={() => setIsFormOpen(false)} />}
    </>
  );
};

export default WebinarPopup;
